import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'
import type { User } from '@/types/user'

export const useProfileStore = defineStore('profile', () => {
  const profile = ref<User | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fellowDataLoading = ref(false)
  const fellowDataError = ref<string | null>(null)

  const fetchUserProfile = async (username: string) => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get(API_ROUTES.GET_USER_PROFILE(username))
      profile.value = response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch user profile'
    } finally {
      isLoading.value = false
    }
  }

  /** Fetches full fellow data by username (GET /api/profiles/fellow-data/by-username/{username}/). */
  const fetchFellowDataByUsername = async (username: string) => {
    fellowDataLoading.value = true
    fellowDataError.value = null
    try {
      const response = await api.get(API_ROUTES.GET_FELLOW_DATA_BY_USERNAME(username))
      return response.data
    } catch (err: any) {
      fellowDataError.value = err.response?.data?.message || 'Failed to fetch fellow data'
      throw err
    } finally {
      fellowDataLoading.value = false
    }
  }

  return {
    profile,
    isLoading,
    error,
    fetchUserProfile,
    fellowDataLoading,
    fellowDataError,
    fetchFellowDataByUsername
  }
})